import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import './style.css'
import Home from './views/home'
import Secretario from './views/secretario'
import SecretarioFeatures from './views/secretario-features'
import SecretarioLearn from './views/secretario-learn'
import PrivacyPolicy from './views/privacy-policy'
import Terms from './views/terms'
import NotFound from './views/not-found'

const App = () => (
  <Router>
    <Switch>
      <Route component={Home} exact path="/" />
      <Route component={Secretario} exact path="/secretario" />
      <Route component={SecretarioFeatures} exact path="/secretario/funcionalidades" />
      <Route component={SecretarioLearn} exact path="/secretario/aprende/:conector?" />
      <Route component={PrivacyPolicy} exact path="/politica-de-privacidad" />
      <Route component={Terms} exact path="/terminos" />
      <Route component={NotFound} />
    </Switch>
  </Router>
)

ReactDOM.render(<App />, document.getElementById('app'))
